import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { cartLinesStyles } from "@dana/Overrides/Widgets/Cart/CartLines";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

cartLinesStyles.noCartLinesIcon = mergeToNew(cartLinesStyles.noCartLinesIcon, {
    mergeCss: true,
    color: themeColors.primary.richBlack,
    css: css`
        path {
            fill: ${themeColors.primary.richBlack};
        }
    `,
});

cartLinesStyles.header = mergeToNew(cartLinesStyles.header, {
    mainSection: {
        css: css`
            justify-content: space-between;
        `,
    },
    warningSection: {
        css: css`
            margin: 5px 0;
            padding: 10px;
        `,
    },
    warningIcon: {
        size: 16,
    },
    warningText: {
        size: fontSizes.small,
        lineHeight: lineHeights.default,
    },
    overflowMenu: {
        mergeCss: true,
        buttonProps: {
            css: css`
                border: none;
            `,
        },
    },
});
